<template>
	<div class="rating">
		<i class="material-icons" v-for="(start, index) in [1, 2, 3, 4, 5]" :key="index" :class="{ active: index < rating }">star</i>
	</div>
</template>

<script>
	export default{
		name: 'Rating',
		props: ['rating']
	}
</script>

<style>
.rating i{
	color: #B2B2B2;
}
.rating i.active{
	color: var(--primary-color);
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>